import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import './index.scss'
import App from './pages/base/App'
import reportWebVitals from './reportWebVitals'
import configureStore from './redux/middleware/configureStore'

const root = ReactDOM.createRoot(document.getElementById('root'))
import * as atatus from 'atatus-spa'
atatus.config('cb5fa61e42954be48cdeebf9d80be42a').install()
root.render(
	<React.StrictMode>
		<Provider store={configureStore()}>
			<App />
		</Provider>
	</React.StrictMode>
)
reportWebVitals()
